import { AttentionTypes } from "../../Definitions";
import { SystemTypes } from "../../Definitions/valueTypes";

  export type System = {
    systemId: number; //DataTYPE ID, static
    systemName: string; 
    systemAttention: AttentionTypes
    systemType: SystemTypes
  };
  
  export const SystemData: System[] = [
    {
      systemId: 1,
      systemName: "Demo",
      systemAttention: AttentionTypes.good,
      systemType: SystemTypes.WalkThrough
    },
    {
      systemId: 2,
      systemName: "Farrowing Unit",
      systemAttention: AttentionTypes.alert,
      systemType: SystemTypes.LocationFeeder
    },
    {
      systemId: 3,
      systemName: "Demo",
      systemAttention: AttentionTypes.neutral,
      systemType: SystemTypes.walkIn
    },
    {
      systemId: 4,
      systemName: "Demo",
      systemAttention: AttentionTypes.good,
      systemType: SystemTypes.ppt
    },
    {
      systemId: 5,
      systemName: "Demo",
      systemAttention: AttentionTypes.warning,
      systemType: SystemTypes.sorter
    }
  ]

